import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoanRepaymentTemplate } from 'app/model/loanrepaymenttemplate';
import { AccountSearchSummary } from 'app/model/accountsearchsummary';
import { LoanScheduleResponse } from 'app/model/loanschedule';
import { Router, ActivatedRoute } from '@angular/router';
import { LoanTransactionsService } from '../loan-transactions.service';
import { SelectedCurrencyOptions } from 'app/model/currencyoptions';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { SettingsService } from 'app/settings/settings.service';
import { DatePipe } from '@angular/common';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { Subscription } from 'rxjs';
import { CheckDetails } from 'app/model/checkdetails';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'mifosx-loan-repayment',
  templateUrl: './loan-repayment.component.html',
  styleUrls: ['./loan-repayment.component.scss']
})
export class LoanRepaymentComponent implements OnInit {
  /** Loan Id */
  loanId: string;

  /** Payment Type Options */
  paymentTypes: any;

  repaymentLoanForm: FormGroup;

  /** Show payment details */
  showPaymentDetails = false;

  /** Show check details */
  showCheckDetailsView: Boolean = false;
  addCheckDetailsFlag: Boolean = false;

  /** Check Details */
  checkDetailsTable = new MatTableDataSource<CheckDetails>();
  checkDetails: Array<CheckDetails> = [];
  checkDetail: CheckDetails = {
    id: 0,
    checkAccountNumber: '',
    checkNumber: '',
    checkSecurityNumber: '',
    checkAmount: '',
    checkAmountToDeposit: '',
    targetName: '',
    countryCode: '',
    currencyCode: null,
    bankCode: '',
    locale: ''
  };
  checkForm: FormGroup;



  /** A summary of loan a ccount from search */
  loanAccountSummary: AccountSearchSummary;

  /** Template to populate loan repayment form */
  loanRepaymentTemplate: LoanRepaymentTemplate;

  /** Flag to control if loan repayment view should be shown */
  showLoanRepaymentView: boolean = false;

  /** Flag to show loan summary view */
  showLoanSummaryView: boolean = false;

  /**System supported currencies */
  currencyOptions: SelectedCurrencyOptions;
  selectedTeller: any;
  isDisabled: boolean = false;
  nextRepaymentDate: string;
  expectedAmount: string;
  expectedAmountValue: number;
  tellerSub: Subscription;
  pageTitle: string = 'Pago de préstamos';
  isQuoteGeneration: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loanService: LoanTransactionsService,
    private receiptService: ReceiptServiceService,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper,
    private settingsService: SettingsService,
    private datePipe: DatePipe,
    private tellerGlobalService: TellerGlobalServiceService) { }

  ngOnInit(): void {
    this.createRepaymentLoanForm();
    this.createCheckForm();
    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
    this.route.data.subscribe(({ supportedCurrencies,loanTemplateData }) => {
      this.currencyOptions = supportedCurrencies;
      this.loanRepaymentTemplate = loanTemplateData;

      if(loanTemplateData){
        this.setDependantFieldsForLoanTemplate(loanTemplateData);
      }
    })

    this.route.paramMap.subscribe(params => {
      this.loanId = params.get('id');
    });

    this.route.pathFromRoot[2].url.subscribe(url => {
      if (url[0].path === 'cotizaciones') {
        this.isQuoteGeneration = true;
        this.pageTitle = 'Generación de cotización';
      }
    });
  }

  ngOnDestroy() {
    this.tellerSub.unsubscribe();
  }
  /**
   * Creates the create close form.
   */
  createRepaymentLoanForm() {
    this.repaymentLoanForm = this.formBuilder.group({
      'transactionDate': [new Date(), Validators.required],
      'transactionAmount': [this.expectedAmountValue, Validators.required],
      'isPrincipleOnlyPayment': '',
      'onlyPrincipalPaymentNointerest': '',
      'adjustNextInstallments': '',
      'isEmiUpdate': '',
      'noOfInstallments': '',
      'paymentTypeId': '',
      'note': '',
      'currencyCode': ''
    });
  }

  createCheckForm() {
    this.checkForm = this.formBuilder.group({
    });
  }

  /**
   * Add payment detail fields to the UI.
   */
  addPaymentDetails() {
    this.showPaymentDetails = !this.showPaymentDetails;
    if (this.showPaymentDetails) {
      this.repaymentLoanForm.addControl('accountNumber', new FormControl(''));
      this.repaymentLoanForm.addControl('checkNumber', new FormControl(''));
      this.repaymentLoanForm.addControl('routingCode', new FormControl(''));
      this.repaymentLoanForm.addControl('receiptNumber', new FormControl(''));
      this.repaymentLoanForm.addControl('bankNumber', new FormControl(''));
    } else {
      this.repaymentLoanForm.removeControl('accountNumber');
      this.repaymentLoanForm.removeControl('checkNumber');
      this.repaymentLoanForm.removeControl('routingCode');
      this.repaymentLoanForm.removeControl('receiptNumber');
      this.repaymentLoanForm.removeControl('bankNumber');
    }
  }

  /**
  * Method to add payment detail fields to the UI.
  */
  addCheckDetails() {
    this.addCheckDetailsFlag = !this.addCheckDetailsFlag;
    if (this.addCheckDetailsFlag) {
      this.checkForm.addControl('checkAccountNumber', new FormControl(''));
      this.checkForm.addControl('chequeNumber', new FormControl(''));
      this.checkForm.addControl('checkSecurityNumber', new FormControl(''));
      this.checkForm.addControl('checkAmount', new FormControl(this.expectedAmountValue));
      this.checkForm.addControl('checkAmountTo', new FormControl(''));
      this.checkForm.addControl('targetName', new FormControl(''));
      this.checkForm.addControl('chequeCountry', new FormControl(1270));
      this.checkForm.addControl('chequeCurrency', new FormControl( this.repaymentLoanForm.controls['currencyCode'].value));
      this.checkForm.addControl('chequeBank', new FormControl(''));
    } else {
      this.checkForm.removeControl('checkAccountNumber');
      this.checkForm.removeControl('chequeNumber');
      this.checkForm.removeControl('checkSecurityNumber');
      this.checkForm.removeControl('checkAmount');
      this.checkForm.removeControl('checkAmountTo');
      this.checkForm.removeControl('targetName');
      this.checkForm.removeControl('chequeCountry');
      this.checkForm.removeControl('chequeCurrency');
      this.checkForm.removeControl('chequeBank');
    }
  }

  updateAccountDetail(event: Array<AccountSearchSummary>) {

    if (event.length > 0) {
      this.loanAccountSummary = event.pop();
      this.showLoanSummaryView = true;
      this.loanId = this.loanAccountSummary.entityId.toString();

      this.loanService.getLoanActionTemplate<LoanRepaymentTemplate>(<string><unknown>this.loanAccountSummary.entityId)
        .subscribe(res => {
          this.loanRepaymentTemplate = res;

          this.setDependantFieldsForLoanTemplate(res)
        });
    } else {
      this.showLoanRepaymentView = false;
    }
  }

  setDependantFieldsForLoanTemplate(res: any) {

    this.showLoanRepaymentView = true;
    this.expectedAmountValue = res.amount;
    this.nextRepaymentDate = this.datePipe.transform(this.loanRepaymentTemplate.date, this.settingsService.dateFormat)
    this.expectedAmount = `${this.loanRepaymentTemplate.amount} (${this.loanRepaymentTemplate.currency.code})`;
    this.repaymentLoanForm.controls['currencyCode'].setValue(this.loanRepaymentTemplate.currency.code);
  }

  checkForEnableCheckOption(value: any) {
    this.showCheckDetailsView = (value === 2 || value === 3);
  }

  clearCheckFields() {
    this.checkForm.get('checkAccountNumber').setValue('');
    this.checkForm.get('chequeNumber').setValue('')
    this.checkForm.get('checkSecurityNumber').setValue('');
    this.checkForm.get('checkAmount').setValue('');
    this.checkForm.get('checkAmountTo').setValue('');
    this.checkForm.get('targetName').setValue('');
    this.checkForm.get('chequeCountry').setValue(1270);
    this.checkForm.get('chequeCurrency').setValue('');
    this.checkForm.get('chequeBank').setValue('');
  }

  addNewCheck() {

    let checkData = {} as CheckDetails;

    checkData.id = this.checkDetails.length;
    checkData.checkAccountNumber = this.checkForm.get('checkAccountNumber').value;
    checkData.checkNumber = this.checkForm.get('chequeNumber').value;
    checkData.checkSecurityNumber = this.checkForm.get('checkSecurityNumber').value;
    checkData.checkAmount = this.checkForm.get('checkAmount').value;
    checkData.checkAmountToDeposit = this.checkForm.get('checkAmount').value;
    checkData.targetName = this.checkForm.get('targetName').value;
    checkData.countryCode = this.checkForm.get('chequeCountry').value;
    checkData.bankCode = this.checkForm.get('chequeBank').value;
    checkData.currencyCode = this.checkForm.get('chequeCurrency').value;
    checkData.targetName = "Automatic";
    checkData.locale = this.settingsService.language.code;

    this.checkDetails.push(checkData);
    this.checkDetailsTable.data = this.checkDetails;
    this.clearCheckFields();

  }

  removeCheck(id: number) {
    this.checkDetails.splice(id, 1);
    this.checkDetailsTable.data = this.checkDetails;

  }

  /** Submits the repayment form */
  submit() {
    this.isDisabled = true;

    let prevTransactionDate: Date = new Date();

    if(this.isQuoteGeneration){
      prevTransactionDate = this.repaymentLoanForm.value.transactionDate;
    }

    // TODO: Update once language and date settings are setup
    const dateFormat = this.settingsService.dateFormat;
    this.repaymentLoanForm.patchValue({
      transactionDate: this.datePipe.transform(prevTransactionDate, dateFormat)
    });

    const prevBankNumber: Date = this.repaymentLoanForm.value.bankNumber;
    this.repaymentLoanForm.patchValue({
      bankNumber: this.datePipe.transform(prevBankNumber, dateFormat)
    });


    const repaymentLoanData = this.repaymentLoanForm.value;
    repaymentLoanData.locale = this.settingsService.language.code;
    repaymentLoanData.dateFormat = dateFormat;
    repaymentLoanData.channel = 'caja';
    if (this.checkDetails.length > 0) {
      repaymentLoanData['checksDetails'] = this.checkDetails
    }

    this.loanService.submitLoanActionButton(<string><unknown>this.loanId, repaymentLoanData, this.isQuoteGeneration ? 'quote': 'repayment')
      .subscribe((res: any) => {
        if(!this.isQuoteGeneration) {
          this.receiptService.getTellerReport(this.selectedTeller['id'], 'Caja_loan_repayment', res['resourceId']).subscribe(data =>
          this.dialogHelper.showDialog(data, this.matDialog, this.router, this.route));
        }else{
          let cotizerParams = {};
          cotizerParams['request'] = repaymentLoanData;
          cotizerParams['response'] = res;

          this.router.navigate(['cotizar'], { relativeTo: this.route,state: { message: cotizerParams } });
        }
      }, error => {
        console.log("Error Pago")
        console.log(error);
        this.isDisabled = false;
      },);

  }

}
